import React, { useState } from "react";
import * as XLSX from "xlsx";
import "./ExportExcelButton.css"
const ExportExcelButton = ({ data, fetchData }) => {
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      const exportData = fetchData ? await fetchData() : data;
      const safeData = Array.isArray(exportData) ? exportData : [];

      if (safeData.length === 0) {
        alert("داده‌ای برای خروجی Excel وجود ندارد!");
        return;
      }

      let rows = [];
      let baseName = "export"; // نام پیش‌فرض
      // کلمه چک عوض شه به

      // total_price بعد از payment_cashو ...
      if (safeData[0].invoice_number) {
        // داده‌های فاکتور
        rows = safeData.map((item) => ({
          "invoice_day_created": item.day_created || "",
          "invoice_month_created": item.month_created || "",
          "invoice_year_created": item.year_created || "",
          "invoice_time_create": item.time_create || "",

          "invoice_number": item.invoice_number || "",
          "invoice_id": item.invoice_id || "",
          "invoice_desc": item.invoice_desc || "",
          "marketer_id": item.marketer_id || "",
          "marketer_name": item.marketer_name || "",
          "marketer_surname": item.marketer_surname || "",

          "marketer_phone_number": item.marketer_phone_number || "",
          "seller_id": item.seller_id || "",
          "seller_name": item.seller_name || "",
          "seller_surname": item.seller_surname || "",

          "seller_phone_number": item.seller_phone_number || "",
          "seller_landline_number": item.seller_landline_number || "",
          "seller_address": item.seller_address || "",
          "seller_city": item.seller_city || "",
          "seller_province": item.seller_province || "",
          "seller_shop_name": item.seller_shop_name || "",
          "product_id": item.product_id || "",
          "product_name": item.product_name || "",
          "product_brand": item.product_brand || "",
          "product_category": item.product_category || "",
          "product_price": item.product_price || 0,
          "product_quantity": item.product_quantity || "",
          "selling_price": item.selling_price || 0,
          "invoice_payment_cash": item.payment_cash || 0,
          "invoice_payment_cash_desc": item.payment_cash_desc || "",
          "invoice_payment_cash_price": item.payment_cash_price || 0,
          "invoice_payment_cheque": item.payment_cheque || 0,
          "invoice_payment_cheque_desc": item.payment_cheque_desc || "",
          "invoice_payment_cheque_price": item.payment_cheque_price || 0,
          "invoice_payment_other": item.payment_other || 0,
          "invoice_payment_other_desc": item.payment_other_desc || "",
          "invoice_payment_other_price": item.payment_other_price || 0,
          "invoice_total_price": item.total_price | 0,

        }));
        baseName = "invoices";
      } else if (safeData[0].id && safeData[0].phone && safeData[0].shop_name && !safeData[0].price) {
        // داده‌های فروشنده
        rows = safeData.map((item) => ({
          "seller_id": item.id || "",
          "seller_name": item.name || "",
          "seller_surname": item.surname || "",
          "seller_phone": item.phone || "",
          "seller_land_line": item.land_line || "",
          "seller_province": item.province || "",
          "seller_city": item.city || "",
          "seller_adress": item.address || "",
          "seller_shop_name": item.shop_name || "",
          "marketer_name": item.marketer_name || "",
          "marketer_surname": item.marketer_surname || "",

          "marketer_phone": item.marketer_phone || "",

        }));
        baseName = "sellers";






      } else if (safeData[0].id && safeData[0].phone) {
        // داده‌های بازدیدکننده
        rows = safeData.map((item) => ({
          "marketer_id": item.id || "",
          "marketer_name": item.name || "",
          "marketer_surname": item.surname || "",
          "marketer_phone": item.phone || "",
          "role": item.role || "",
          "marketer_address": item.address || "",
        }));
        baseName = "visitors";
      } else if (safeData[0].id && safeData[0].price) {
        // داده‌های محصولات جدید
        rows = safeData.map((item) => ({
          "product_id": item.id || "",
          "product_name": item.name || "",
          "product_brand": item.brand || "",
          "product_category": item.category || "",
          "product_price": item.price || 0,
        }));
        baseName = "products";
      } else {
        alert("نوع داده ناشناخته است!");
        return;
      }

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(rows);
      XLSX.utils.book_append_sheet(wb, ws, "Export");

      // اضافه کردن تاریخ به اسم فایل
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const dd = String(today.getDate()).padStart(2, "0");
      const fileName = `${baseName}_${yyyy}-${mm}-${dd}.xlsx`;

      XLSX.writeFile(wb, fileName);
    } catch (error) {
      console.error("خطا در گرفتن داده‌ها یا خروجی Excel:", error);
      alert("خطا در خروجی Excel");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleExport}
      disabled={loading}
      className="export-btn"
    >
      {loading ? "در حال دریافت داده..." : "دانلود Excel"}
    </button>

  );
};

export default ExportExcelButton;
